import { expectEls, expectGameContext } from "../../util";
import { updateNavBtns } from ".";

export function playVideo() {
    const ctx = expectGameContext();
    ctx.gameState.isPlaying = true;
    expectEls<HTMLVideoElement>("#game .videos .video.active")
        .filter((v) => v.paused)
        .forEach((v) => v.play());
    updateNavBtns();
}

export function pauseVideo() {
    const ctx = expectGameContext();
    ctx.gameState.isPlaying = false;
    expectEls<HTMLVideoElement>("#game .videos .video")
        .filter((v) => !v.paused)
        .forEach((v) => v.pause());
    updateNavBtns();
}

export function togglePlay() {
    const ctx = expectGameContext();
    if (ctx.gameState.isPlaying) {
        pauseVideo();
    } else {
        playVideo();
    }
}
